import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { FAQ as FAQData } from "../../data/mock";

const FAQ = () => {
  return (
    <section id="faq" className="py-24 bg-[var(--bg-page)] transition-theme">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[var(--accent-wash)] text-[var(--accent-text)] text-sm font-medium mb-4">
            FAQ
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[var(--text-primary)] mb-6 leading-tight">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-[var(--text-body)] opacity-90">
            Find answers to common questions about SEFIL 360.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {FAQData.map((item) => (
            <AccordionItem
              key={item.id}
              value={`item-${item.id}`}
              className="border border-[var(--border-light)] rounded-xl px-6 bg-[var(--bg-card)] hover:border-[var(--accent-primary)]/30 transition-colors data-[state=open]:border-[var(--accent-primary)]/50 data-[state=open]:shadow-lg data-[state=open]:shadow-[var(--accent-primary)]/5"
            >
              <AccordionTrigger className="text-left text-[var(--text-primary)] font-semibold hover:no-underline py-5 [&[data-state=open]]:text-[var(--accent-text)]">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-[var(--text-body)] opacity-90 pb-5 leading-relaxed">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Additional Help */}
        <div className="mt-12 text-center">
          <p className="text-[var(--text-body)] opacity-85 mb-4">
            Still have questions? We're here to help.
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 text-[var(--accent-text)] font-medium hover:underline"
          >
            Contact our support team
            <span className="text-lg">→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
